import script from "./FaqVue.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqVue.vue?vue&type=script&setup=true&lang=js"

import "./FaqVue.vue?vue&type=style&index=0&id=1a40b1c7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a40b1c7"]])

export default __exports__